import { API_BASE_URL } from '../services/api';
// Utility function to construct proper image URLs
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path, construct the full URL
  const apiBaseUrl = API_BASE_URL;
  return `${apiBaseUrl}/${imagePath}`;
};

// Utility function to get business photo URL
export const getBusinessPhotoUrl = (business) => {
  const photoPath = business?.businessPhoto || business?.profile_photo || business?.photo;
  return getImageUrl(photoPath);
};

// Utility function to check if image URL is valid
export const isValidImageUrl = (url) => {
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/');
};

// Utility function to get fallback image
export const getFallbackImage = (type = 'business') => {
  const fallbackImages = {
    business: '/images/placeholder-business.jpg',
    interior: '/images/placeholder-interior.jpg',
    products: '/images/placeholder-products.jpg',
    team: '/images/placeholder-team.jpg',
    user: '/images/placeholder-user.jpg'
  };
  return fallbackImages[type] || fallbackImages.business;
}; 